<template>
    <div>
        <table style="width: 100%;">
            <tr>
                <!-- 無線機設定の選択 -->
                <td style="width: 280px; vertical-align:top">
                    <table>
                        <tr>
                            <td>
                                <div class="header-gray" v-t="'message.item_ip_radio_setting'">
                                    無線機設定
                                </div>

                                <el-select style="width: 100%;"
                                           v-model="selectedModel"
                                           :placeholder="$t('message.action_ip_radio_select_model')"
                                            @change="onModelSelect">
                                    <el-option
                                        v-for="item in modelList"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select>

                                <div style="height: calc(100vh - 216px); overflow:auto">
                                    <el-tree class="settings-tree"
                                             :data="settingsToShow"
                                             :props="treeProps"
                                             node-key="id"
                                             highlight-current
                                             　　ref="settingsTree"
                                             　　@node-click="onNodeClick"
                                    >
                                        <template v-slot="{ node, data }">
                                            <el-tooltip :content="data.displayName" placement="top" :disabled="data.displayName.length < 34">
                                                <span class="tree-node-label">{{ data.displayName }}</span>
                                            </el-tooltip>
                                        </template>
                                    </el-tree>
                                </div>

                                <div style="border-bottom: 1px #eee solid; min-width: 280px;"></div>

                                <template v-if="canManageDefinition">
                                    <button class="transparent-button" type="button" v-on:click="onClickCreateButton">
                                        <img src="../../../../assets/add_user.svg"/>
                                        <span class="normal-command-text" v-t="'message.action_ip_radio_add_setting'"></span>
                                    </button>
                                    <button class="transparent-button" type="button" v-on:click="onClickImportButton">
                                        <img src="../../../../assets/add_user.svg"/>
                                        <span class="normal-command-text" v-t="'message.action_ip_radio_import_setting'"></span>
                                    </button>
                                </template>

                                <!-- 非表示のファイル選択入力 -->
                                <input
                                    type="file"
                                    ref="fileInput"
                                    accept="text/plain,.dat"
                                    multiple
                                    style="display: none;"
                                    @change="onFileSelected"
                                />
                            </td>
                        </tr>
                    </table>
                </td>

                <!-- 区切り -->
                <td style="width: 1px; background: #ddd;"></td>

                <!-- 選択項目の表示 -->
                <td style="vertical-align: top;">
                    <table style="width: 100%">
                        <tr>
                            <td>
                                <div class="header-gray" style="padding-top: 6px; padding-bottom: 6px;">
                                    <table style="width: 100%">
                                        <tr>
                                            <td>
                                                <div>
                                                    <span v-if="selectedSetting != null">{{
                                                            selectedSetting.displayName
                                                        }}</span>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="object-titlebox">
                                                    <div class="object-titlebox-right">
                                                        <button v-if="canManageDefinition" class="transparent-button" type="button" v-on:click="onClickDeleteButton()">
                                                            <img src="../../../../assets/delete.svg" alt="trash"/>
                                                            <span class="important-command-text" v-t="'message.common_action_delete'"></span>
                                                        </button>
                                                        <button v-if="canManageDefinition" class="transparent-button" type="button" v-on:click="onClickExportButton()">
                                                            <img src="../../../../assets/icon_download.svg" alt="export"/>
                                                            <span class="normal-command-text" v-t="'message.button_export'"></span>
                                                        </button>
                                                        <button v-if="canManageDefinition || canEditWifiItemsOnly" class="transparent-button" type="button" v-on:click="onClickEditButton()">
                                                            <img src="../../../../assets/edit.svg" alt="edit"/>
                                                            <span class="normal-command-text" v-t="'message.common_action_edit'"></span>
                                                        </button>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </table>
                                </div>

                                <div>
                                    <BCRadioSettings v-if="selectedSettingJsonContent" :setting="selectedSettingJsonContent" />
                                    <div v-else>機種と設定を選択してください。</div>
                                </div>
                            </td>
                        </tr>
                    </table>
                </td>
            </tr>
        </table>

        <IpRadioSettingCreateDialog
            :visible.sync="showCreateDialog"
            :modelName="selectedModel"
            :existingSettings="settingsToShow"
            @save="createSetting"
        />

        <BCRadioSettingsEditDialog
            :settingId="selectedSetting != null ? selectedSetting.id : null"
            :setting="selectedSettingJsonContent"
            :settingName="selectedSetting != null ? selectedSetting.displayName : null"
            :appData="appData"
            :visible.sync="showEditDialog"
            @save="updateSetting"
        />

        <DeleteObject
            v-if="showDeleteDialog"
            :confirmInfo="{objectTitle: '無線機設定', objectName: selectedSetting.displayName }"
            @delete="deleteSetting(selectedSetting.id);showDeleteDialog=false"
            @cancel="showDeleteDialog=false"/>

    </div>
</template>

<script>
import server from "@/components/ServerApi.js";
import constants from "@/components/constants.js";
import commonUtil from '@/components/commonutil.js';
import DeleteObject from "@/components/DeleteObject.vue";
import BCRadioSettings from './BCRadioSettings.vue';
import BCRadioSettingsEditDialog from "./organisms/dialog/BCRadioSettingsEditDialog.vue";
import IpRadioSettingCreateDialog from "./IpRadioSettingCreateDialog.vue";

export default {
    components: {
        IpRadioSettingCreateDialog,
        DeleteObject,
        BCRadioSettings,
        BCRadioSettingsEditDialog
    },

    props: {
        appData: Object,
    },

    data() {
        return {
            // Element UI の el-tree 用 props
            treeProps: {
                label: 'displayName'
            },

            selectedModel: null,
            selectedSetting: null,
            selectedSettingJsonContent: null,

            modelList: [],
            settingsToShow: [],

            showCreateDialog: false,
            showEditDialog: false,
            showDeleteDialog: false,
        }
    },

    computed: {
        canManageDefinition() {
            return commonUtil.canManageRadioSettingDefinition(this.appData);
        },
        canEditWifiItemsOnly() {
            return commonUtil.canEditRadioSettingWifiItems(this.appData);
        }
    },

    created: function() {
        this.fetchModelList();
    },

    methods: {
        onModelSelect(model) {
            this.selectedModel = model;
            this.fetchSettingList();
        },

        onNodeClick(nodeData) {
            this.selectedSetting = nodeData
            this.fetchSetting(nodeData.id);
        },

        onClickCreateButton() {
            if (this.selectedModel == null) {
                commonUtil.notifyMessage(this, "Info", '機種を選択してください。')
                return;
            }

            this.showCreateDialog = true
        },

        async onClickEditButton() {
            if (this.selectedSetting == null) {
                commonUtil.notifyMessage(this, "Info", '無線機設定を選択してください。')
                return;
            }

            // 編集ロックチェック
            const canEdit = await this.checkEditLock(this.selectedSetting.id)
            if (!canEdit) {
                return;
            }

            this.showEditDialog = true
        },

        async onClickDeleteButton() {
            if (this.selectedSetting == null) {
                commonUtil.notifyMessage(this, "Info", '無線機設定を選択してください。')
                return;
            }

            // 編集ロックチェック
            const canEdit = await this.checkEditLock(this.selectedSetting.id)
            if (!canEdit) {
                return;
            }

            this.showDeleteDialog = true
        },

        async onClickExportButton() {
            if (this.selectedSetting == null) {
                commonUtil.notifyMessage(this, "Info", '無線機設定を選択してください。')
                return;
            }

            // 編集ロックチェック
            const canEdit = await this.checkEditLock(this.selectedSetting.id)
            if (!canEdit) {
                return;
            }

            await this.exportSetting();
        },

        onClickImportButton() {
            if (this.selectedModel == null) {
                commonUtil.notifyMessage(this, "Info", '機種を選択してください。')
                return;
            }
            if (this.$refs.fileInput) {
                this.$refs.fileInput.click();
            }
        },

        async fetchModelList() {
            let response
            try {
                response = await server.post('/getipradiomodellist')
            } catch (error) {
                commonUtil.putExceptionErrorMessage(this, "fetchModelList", error);
            }

            const responseStatus = response.data.status;
            switch (responseStatus) {
                case constants.STATUS_SUCCESS:
                    this.modelList = response.data.modelList.map(model => ({value:model, label:model}));
                    this.onModelSelect(this.modelList[0].value);
                    break;
                default:
                    commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_server_api").replace("{functionName}", "fetchModelList").replace("{code}", responseStatus))
                    break;
            }
        },

        async fetchSettingList() {
            let response
            try {
                response = await server.post('/getipradiosettinglist', {model: this.selectedModel})
            } catch (error) {
                commonUtil.putExceptionErrorMessage(this, "fetchSettingList", error);
            }

            const responseStatus = response.data.status;
            switch (responseStatus) {
                case constants.STATUS_SUCCESS:
                    this.settingsToShow = response.data.settings;
                    break;
                default:
                    commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_server_api").replace("{functionName}", "fetchSettingList").replace("{code}", responseStatus))
                    break;
            }
        },

        async fetchSetting(settingId) {
            let response
            try {
                response = await server.post('/getipradiosetting', {ipRadioSettingId: settingId})
            } catch (error) {
                commonUtil.putExceptionErrorMessage(this, "fetchSetting", error);
            }

            const responseStatus = response.data.status;
            switch (responseStatus) {
                case constants.STATUS_SUCCESS:
                    const object = JSON.parse(response.data.setting);
                    this.selectedSettingJsonContent = object;
                    break;
                default:
                    commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_server_api").replace("{functionName}", "fetchSettings").replace("{code}", responseStatus))
                    break;
            }
        },

        async createSetting(settingName, copySettingId) {
            let response
            try {
                response = await server.post('/createipradiosetting', {model: this.selectedModel, displayName: settingName, copySettingId: copySettingId})
            } catch (error) {
                commonUtil.putExceptionErrorMessage(this, "createSetting", error);
            }

            const responseStatus = response.data.status;
            switch (responseStatus) {
                case constants.STATUS_SUCCESS:
                    const newSetting = {id: response.data.id, displayName: response.data.displayName}
                    this.settingsToShow.push(newSetting);

                    // 作成した設定を選択状態に
                    this.$nextTick(() => {
                        if (this.$refs.settingsTree) {
                            this.$refs.settingsTree.setCurrentKey(newSetting.id)
                        }
                        this.onNodeClick(newSetting)
                    })
                    commonUtil.notifyMessage(this, "Success", "無線機設定を作成しました。")
                    this.showCreateDialog = false
                    break;
                case constants.STATUS_ERROR_ALREADY_EXISTED:
                    commonUtil.notifyMessage(this, "Warning", "既に存在する無線機設定名です。")
                    break;
                case constants.STATUS_ERROR_EXCEEDS_MAX_COUNT:
                    commonUtil.notifyMessage(this, "Warning", "無線機設定の作成数上限のため作成できませんでした。")
                    break;
                case constants.STATUS_ERROR_OBJECT_NOT_FOUND:
                    commonUtil.notifyMessage(this, "Warning", "複製する設定が削除されているため作成できません。")
                    break;
                default:
                    commonUtil.notifyMessage(this, "Warning", "無線機設定の作成に失敗しました。")
                    break;
            }
        },

        async deleteSetting(settingId) {
            let response
            try {
                response = await server.post('/deleteipradiosetting', {ipRadioSettingId: settingId})
            } catch (error) {
                commonUtil.putExceptionErrorMessage(this, "deleteSetting", error);
            }

            const responseStatus = response.data.status;
            switch (responseStatus) {
                case constants.STATUS_SUCCESS:
                    this.settingsToShow = this.settingsToShow.filter(setting => setting.id !== settingId);
                    this.selectedSetting = null;
                    this.selectedSettingJsonContent = null;
                    commonUtil.notifyMessage(this, "Success", "無線機設定を削除しました。")
                    break;
                case constants.STATUS_ERROR_STILL_ASSIGNED:
                    commonUtil.notifyMessage(this, "Warning", commonUtil.getMessageText(this.$i18n, "error_ip_radio_setting_still_assigned"))
                    break;
                default:
                    commonUtil.notifyMessage(this, "Warning", "無線機設定の削除に失敗しました。")
                    break;
            }
        },

        async updateSetting(settingName, setting) {
            let response
            try {
                response = await server.post('/updateipradiosetting',
                    {
                        ipRadioSettingId: this.selectedSetting.id,
                        displayName: settingName,
                        setting: JSON.stringify(setting)
                    })
            } catch (error) {
                commonUtil.putExceptionErrorMessage(this, "updateSetting", error);
            }

            const responseStatus = response.data.status;
            switch (responseStatus) {
                case constants.STATUS_SUCCESS:
                    const settingIndex = this.settingsToShow.findIndex(s => s.id === this.selectedSetting.id);
                    if (settingIndex !== -1) {
                        this.settingsToShow[settingIndex].displayName = settingName;
                    }
                    this.selectedSetting.displayName = settingName;
                    this.selectedSettingJsonContent = setting;
                    commonUtil.notifyMessage(this, "Success", "無線機設定を更新しました。")
                    break;
                case constants.STATUS_ERROR_ALREADY_EXISTED:
                    commonUtil.notifyMessage(this, "Warning", "既に存在する無線機設定名です。")
                    break;
                default:
                    if (response.data.message) {
                        const message = response.data.message[this.$i18n.locale];
                        commonUtil.notifyMessage(this, "Warning", "無線機設定の更新に失敗しました。" + message)
                    } else {
                        commonUtil.notifyMessage(this, "Warning", "無線機設定の更新に失敗しました。")
                    }
                    break;
            }
        },

        async checkEditLock(ipRadioSettingId) {
            try {
                const response = await server.post('/checkipradiosettingeditlock', { ipRadioSettingId })
                const status = response.data.status
                if (status !== constants.STATUS_SUCCESS) {
                    // サーバーエラーは編集を止める
                    commonUtil.notifyMessage(this, "Warning", commonUtil.getMessageText(this.$i18n, "error_server_api").replace("{functionName}", "checkEditLock").replace("{code}", status))
                    return false
                }
                if (response.data.isLocked) {
                    const message = `この無線機設定は他のユーザーが編集中です。\n編集ユーザー: ${response.data.userName}`
                    commonUtil.notifyMessage(this, "Warning", message)
                    return false
                }
                return true
            } catch (error) {
                commonUtil.putExceptionErrorMessage(this, "checkEditLock", error);
                return false
            }
        },

        async exportSetting() {
            let response
            try {
                response = await server.post('/exportipradiosetting', { ipRadioSettingId: this.selectedSetting.id })
            } catch (error) {
                commonUtil.putExceptionErrorMessage(this, "exportSetting", error);
                return;
            }

            const responseStatus = response.data.status;
            switch (responseStatus) {
                case constants.STATUS_SUCCESS:
                    this.downloadDatFile(response.data.setting, this.selectedSetting.displayName)
                    break;
                case constants.STATUS_ERROR_NOT_FOUND:
                    commonUtil.notifyMessage(this, "Warning", '無線機設定が見つかりません。')
                    break;
                default:
                    commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_server_api").replace("{functionName}", "exportSetting").replace("{code}", responseStatus))
                    break;
            }
        },

        downloadDatFile(datText, displayName) {
            const filename = `${displayName}.dat`;
            const blob = new Blob([datText + '\n'], { type: 'text/plain;charset=utf-8' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = filename;
            document.body.appendChild(link);
            link.click();

            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        },

        async onFileSelected(event) {
            const files = Array.from(event.target.files || []);
            if (files.length === 0) return;

            if (files.length > 100) {
                commonUtil.notifyMessage(this, 'Warning', `1度に指定できるファイルは100件です。`)
                return;
            }

            const invalidFiles = files.filter(file => {
                const fileName = file.name.toLowerCase();
                return !fileName.endsWith('.dat');
            });

            if (invalidFiles.length > 0) {
                commonUtil.notifyMessage(this, 'Warning', `拡張子が.dat のファイルを選択してください。`);
                event.target.value = '';
                return;
            }

            let successCount = 0;
            let failCount = 0;
            const errors = [];

            for (const file of files) {
                try {
                    const result = await this.importSingleFile(file);
                    if (result && result.success) {
                        successCount++;
                        if (result.id && result.displayName) {
                            // その場でリストに反映
                            this.settingsToShow.push({id: result.id, displayName: result.displayName});
                        }
                    } else if (result && !result.continue) {
                        failCount += files.length - successCount;
                        if (result && result.error) {
                            errors.push(result.error);
                        }
                        break;
                    } else {
                        failCount++;
                        if (result && result.error) {
                            errors.push(result.error);
                        } else {
                            errors.push(`${file.name}: インポートに失敗しました`);
                        }
                    }
                } catch (e) {
                    failCount++;
                    errors.push(`${file.name}: ${e && e.message ? e.message : 'インポートに失敗しました'}`);
                }
            }

            await this.showImportResult(successCount, failCount, errors);
            // 入力をリセット
            if (event && event.target) {
                event.target.value = '';
            }
        },

        importSingleFile(file) {
            return new Promise((resolve) => {
                const displayName = file.name.replace(/\.dat$/i, '');
                const reader = new FileReader();
                reader.onload = async (e) => {
                    const settingText = e && e.target ? e.target.result : null;
                    if (!settingText) {
                        resolve({ success: false, error: `${displayName}: ファイルの読み込みに失敗しました` });
                        return;
                    }

                    let response;
                    try {
                        response = await server.post('/importipradiosetting', {
                            model: this.selectedModel,
                            displayName: displayName,
                            setting: settingText
                        });
                    } catch (error) {
                        commonUtil.putExceptionErrorMessage(this, 'importSingleFile', error);
                        resolve({ success: false, error: `${displayName}: サーバー呼び出しに失敗しました` });
                        return;
                    }

                    const status = response.data.status;
                    switch (status) {
                        case constants.STATUS_SUCCESS:
                            resolve({ success: true, id: response.data.id, displayName: response.data.displayName });
                            break;
                        case constants.STATUS_ERROR_ALREADY_EXISTED:
                            resolve({ success: false, continue:true, error: `${displayName}: 同名の設定が既に存在します` });
                            break;
                        case constants.STATUS_ERROR_INVALID_PARAMETER:
                            resolve({ success: false, continue:true, error: `${displayName}: ファイル形式が不正です` });
                            break;
                        case constants.STATUS_ERROR_EXCEEDS_MAX_COUNT:
                            resolve({ success: false, continue:false, error: '無線機設定の作成数上限のため作成できませんでした。' });
                            break;
                        default:
                            resolve({ success: false, continue:false, error: commonUtil.getMessageText(this.$i18n, "error_server_api").replace("{functionName}", "importIpRadioSetting").replace("{code}", status) });
                            break;
                    }
                };
                reader.onerror = () => {
                    resolve({ success: false, error: `${displayName}: ファイルの読み込みに失敗しました` });
                };
                reader.readAsText(file);
            });
        },

        async showImportResult(successCount, failCount, errors) {
            if (successCount > 0 && failCount === 0) {
                commonUtil.notifyMessage(this, 'Success', `${successCount}件の設定をインポートしました。`)
                await this.fetchSettingList();
                return;
            } else if (successCount === 0 && failCount > 0) {
                commonUtil.notifyMessage(this, 'Warning', 'インポートに失敗しました。');
                for (const error of errors) {
                    await this.$nextTick(); // notifyの出現位置が重なるため、直前の notify の DOM 更新を待つ
                    commonUtil.notifyMessage(this, 'Warning', error, null, 'ip-radio-setting-import-notification'
                    );
                }
            } else {
                commonUtil.notifyMessage(this, 'Warning', `${successCount}件成功、${failCount}件失敗しました。`)
                for (const error of errors) {
                    await this.$nextTick(); // notifyの出現位置が重なるため、直前の notify の DOM 更新を待つ
                    commonUtil.notifyMessage(this, 'Warning', error, null, 'ip-radio-setting-import-notification'
                    );
                }
            }

            if (successCount > 0) {
                await this.fetchSettingList();
            }
        }
    }
}

</script>

<style scoped>
.header-gray {
    padding: 10px 20px 10px 20px;
    font-size: 12px;
    vertical-align: middle;
    background-color: #f6f6f6;
    color: #848991;
}

:deep(.settings-tree .el-tree-node__expand-icon) {
    display: none !important;
}

.tree-node-label {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
    max-width: 265px;
    padding-left: 10px;
}

</style>

<!-- ★ Notification用のグローバルスタイル ★ -->
<style>
.ip-radio-setting-import-notification .el-notification__group .el-notification__content {
    word-break: break-all;
}
</style>
